// Environment variables with fallbacks
const config = {
  // API URL - defaults to localhost for development
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001',
  // Socket.io options
  SOCKET_OPTIONS: {
    withCredentials: true,
    secure: process.env.NODE_ENV === 'production' // Only use secure in production
  },
  // Game configuration - match server settings
  WINNING_POINTS: parseInt(process.env.REACT_APP_GAME_WIN_POINTS, 10) || 100, // Match server's default
  EARTHQUAKE_COOLDOWN: parseInt(process.env.REACT_APP_EARTHQUAKE_COOLDOWN, 30) || 30
};

export default config; 